import {Chip} from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

// "Pretty" status renderer for AnalysisRequest - a real MUI Chip with an
// icon/color per status. Originally consumer-only; the coach/admin list
// (renderAnalysisRequestStatus in entities/Lists.js) now reuses it too, so
// both sides of the app show the same status colors (DRAFT no color,
// SUBMITTED orange, ACCEPTED blue, COMPLETED green, REJECTED red) - kept
// here rather than duplicated into Lists.js.
export const STATUS_META={
    DRAFT:{color:'default',icon:EditNoteIcon},
    SUBMITTED:{color:'warning',icon:HourglassTopIcon},
    ACCEPTED:{color:'info',icon:AutorenewIcon},
    COMPLETED:{color:'success',icon:CheckCircleIcon},
    REJECTED:{color:'error',icon:ErrorOutlineIcon},
};

// Lifecycle order - used to order the status filter chips on the My Analyses list.
export const STATUS_ORDER=['DRAFT','SUBMITTED','ACCEPTED','COMPLETED','REJECTED'];

// The list endpoint (AnalysisRequest.get_list_formatted) returns the status
// column already resolved to its localized LOV label, not the raw code - the
// same reason entities/Lists.js keeps a reverse lookup for its own status
// renderer. Detail/create instead go through the generic record serializer
// (build_record_metadata), which for any list_of_values column also resolves
// "value" to the localized label and stashes the raw code separately as
// "value_db" - callers there must pass single_fields.status.value_db, not
// .value, to land on the same raw code as resolveStatusCode() produces below.
export const resolveStatusCode=(statusLabel,application)=>{
    if(!statusLabel) return null;
    return application?.globalData?.list_of_values_reverse?.AnalysisRequest_Status?.[statusLabel]||statusLabel;
};

const MyAnalysisStatusChip=({statusCode,application,size='medium'})=>{
    if(!statusCode) return null;
    const meta=STATUS_META[statusCode]||STATUS_META.DRAFT;
    const Icon=meta.icon;
    const label=application?.globalData?.list_of_values?.AnalysisRequest_Status?.[statusCode]||statusCode;
    return (
        <Chip
            size={size}
            color={meta.color}
            icon={<Icon/>}
            label={label}
            variant={statusCode==='DRAFT'?'outlined':'filled'}
        />
    );
};

export default MyAnalysisStatusChip;
